import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContentHubLinkComponentModule } from "../../../shared/ui/content-hub-link/content-hub-link.component.module";
import { IconsModule } from "../../../shared/ui/icons/icons.module";
import { PageFooterComponentModule } from "../../../shared/ui/page-footer/page-footer.component.module";
import { SpxButtonComponentModule } from "../../../shared/ui/spx-button/spx-button.component.module";
import { SpxSectionComponentModule } from "../../../shared/ui/spx-section/spx-section.component.module";
import { StatsComponentModule } from "../../../shared/ui/stats/stats.component.module";
import { SwiperComponentModule } from "../../../shared/ui/swiper/swiper.component.module";
import { MetricTileComponentModule } from "../../../shared/ui/tiles/metric-tile/metric-tile.component.module";
import { TitleTileComponentModule } from "../../../shared/ui/tiles/title-tile/title-tile.component.module";
import { VideoTileComponentModule } from "../../../shared/ui/tiles/video-tile/video-tile.component.module";
import { MarsAndBeyondPage } from "./mars-and-beyond.page";
import { MarsAndBeyondPageRoutingModule } from "./mars-and-beyond.page.routing.module";


@NgModule({
  imports: [
    CommonModule,
    MarsAndBeyondPageRoutingModule,
    SpxButtonComponentModule,
    IconsModule,
    MetricTileComponentModule,
    PageFooterComponentModule,
    SpxSectionComponentModule,
    SwiperComponentModule,
    StatsComponentModule,
    TitleTileComponentModule,
    VideoTileComponentModule,
    ContentHubLinkComponentModule
  ],
  declarations: [MarsAndBeyondPage],
  providers: [{ provide: Window, useValue: window }],
})
export class MarsAndBeyondPageModule { }
